'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeClientTrigger = undefined;

var _WidgetActions = require('../../actions/WidgetActions');

var _getPopOpenWidget = require('../../selectors/widgetDataSelectors/getPopOpenWidget');

var _toggleInitialMessageBubble = require('../../initial-message-bubble/actions/toggleInitialMessageBubble');

var _removeClientTriggers = require('./removeClientTriggers');

var executeClientTrigger = exports.executeClientTrigger = function executeClientTrigger() {
  return function (dispatch, getState) {
    dispatch((0, _removeClientTriggers.removeClientTriggers)());

    if ((0, _getPopOpenWidget.getPopOpenWidget)(getState())) {
      dispatch((0, _WidgetActions.toggleOpen)(true));
    } else {
      dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(true));
    }
  };
};